import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Row, Col, Alert } from 'reactstrap';

const rewardValueDefaults = {
  topup: { topup: 10000, description: '' },
  points: { points: 1000, description: '' },
  badge: { badgeName: '', badgeIcon: '🏆', description: '' },
  voucher: { voucherCode: '', description: '' },
  gift: { giftName: '', giftValue: 0, description: '' },
  coupon: { couponCode: '', discountValue: 0, description: '' },
  discount: { discountPercent: 10, maxDiscount: 50000, description: '' },
  freeship: { maxValue: 30000, minOrder: 0, description: '' }
};

const RewardModal = ({
  isOpen,
  toggle,
  editingReward,
  formData,
  setFormData,
  onSubmit,
  quizOptions = [],
  quizOptionsLoading = false,
  getNextSortOrder
}) => {
  const ensureRewardValue = (type) => {
    if (!formData.rewardValue || typeof formData.rewardValue !== 'object') {
      setFormData((prev) => ({
        ...prev,
        rewardValue: rewardValueDefaults[type] || { description: '' }
      }));
      return rewardValueDefaults[type] || { description: '' };
    }
    return formData.rewardValue;
  };

  const rewardValue = ensureRewardValue(formData.rewardType);

  const handleRewardTypeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      rewardType: value,
      rewardValue: rewardValueDefaults[value] ? { ...rewardValueDefaults[value] } : { description: '' }
    }));
  };

  const updateRewardValueField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      rewardValue: {
        ...prev.rewardValue,
        [field]: value
      }
    }));
  };

  const renderRewardValueInputs = () => {
    switch (formData.rewardType) {
      case 'topup':
        return (
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Số tiền topup (VNĐ)</Label>
                <Input
                  type="number"
                  value={rewardValue.topup || ''}
                  onChange={(e) => updateRewardValueField('topup', parseInt(e.target.value) || 0)}
                  placeholder="10000"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Mô tả</Label>
                <Input
                  type="text"
                  value={rewardValue.description || ''}
                  onChange={(e) => updateRewardValueField('description', e.target.value)}
                  placeholder="Xuất sắc! Bạn đã chinh phục toàn bộ câu hỏi 🎉"
                />
              </FormGroup>
            </Col>
          </Row>
        );
      case 'points':
        return (
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Số điểm</Label>
                <Input
                  type="number"
                  value={rewardValue.points || ''}
                  onChange={(e) => updateRewardValueField('points', parseInt(e.target.value) || 0)}
                  placeholder="1000"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Mô tả</Label>
                <Input
                  type="text"
                  value={rewardValue.description || ''}
                  onChange={(e) => updateRewardValueField('description', e.target.value)}
                  placeholder="Giải thưởng điểm thưởng"
                />
              </FormGroup>
            </Col>
          </Row>
        );
      case 'badge':
        return (
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Tên badge</Label>
                <Input
                  type="text"
                  value={rewardValue.badgeName || ''}
                  onChange={(e) => updateRewardValueField('badgeName', e.target.value)}
                  placeholder="Người chinh phục"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label>Icon</Label>
                <Input
                  type="text"
                  value={rewardValue.badgeIcon || ''}
                  onChange={(e) => updateRewardValueField('badgeIcon', e.target.value)}
                  placeholder="🏆"
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label>Mô tả</Label>
                <Input
                  type="text"
                  value={rewardValue.description || ''}
                  onChange={(e) => updateRewardValueField('description', e.target.value)}
                  placeholder="Bạn đã đạt được huy hiệu vàng!"
                />
              </FormGroup>
            </Col>
          </Row>
        );
      case 'voucher':
        return (
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Mã voucher</Label>
                <Input
                  type="text"
                  value={rewardValue.voucherCode || ''}
                  onChange={(e) => updateRewardValueField('voucherCode', e.target.value)}
                  placeholder="VOUCHER123"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Mô tả</Label>
                <Input
                  type="text"
                  value={rewardValue.description || ''}
                  onChange={(e) => updateRewardValueField('description', e.target.value)}
                  placeholder="Giảm 100k cho đơn hàng tiếp theo"
                />
              </FormGroup>
            </Col>
          </Row>
        );
      case 'gift':
        return (
          <>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Tên quà tặng</Label>
                  <Input
                    type="text"
                    value={rewardValue.giftName || ''}
                    onChange={(e) => updateRewardValueField('giftName', e.target.value)}
                    placeholder="Túi quà tặng RVOPV"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Giá trị quà (VNĐ)</Label>
                  <Input
                    type="number"
                    value={rewardValue.giftValue || 0}
                    onChange={(e) => updateRewardValueField('giftValue', parseInt(e.target.value) || 0)}
                    placeholder="50000"
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Mô tả</Label>
              <Input
                type="text"
                value={rewardValue.description || ''}
                onChange={(e) => updateRewardValueField('description', e.target.value)}
                placeholder="Phần quà đặc biệt dành cho bạn"
              />
            </FormGroup>
          </>
        );
      case 'coupon':
        return (
          <>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Mã coupon</Label>
                  <Input
                    type="text"
                    value={rewardValue.couponCode || ''}
                    onChange={(e) => updateRewardValueField('couponCode', e.target.value)}
                    placeholder="COUPON50"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Giá trị giảm (VNĐ)</Label>
                  <Input
                    type="number"
                    value={rewardValue.discountValue || 0}
                    onChange={(e) => updateRewardValueField('discountValue', parseInt(e.target.value) || 0)}
                    placeholder="50000"
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Mô tả</Label>
              <Input
                type="text"
                value={rewardValue.description || ''}
                onChange={(e) => updateRewardValueField('description', e.target.value)}
                placeholder="Áp dụng cho đơn hàng tiếp theo của bạn"
              />
            </FormGroup>
          </>
        );
      case 'discount':
        return (
          <>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Phần trăm giảm (%)</Label>
                  <Input
                    type="number"
                    value={rewardValue.discountPercent || 0}
                    onChange={(e) => updateRewardValueField('discountPercent', parseInt(e.target.value) || 0)}
                    placeholder="50"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Giảm tối đa (VNĐ)</Label>
                  <Input
                    type="number"
                    value={rewardValue.maxDiscount || 0}
                    onChange={(e) => updateRewardValueField('maxDiscount', parseInt(e.target.value) || 0)}
                    placeholder="50000"
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Mô tả</Label>
              <Input
                type="text"
                value={rewardValue.description || ''}
                onChange={(e) => updateRewardValueField('description', e.target.value)}
                placeholder="Giảm giá hấp dẫn dành riêng cho bạn"
              />
            </FormGroup>
          </>
        );
      case 'freeship':
        return (
          <>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Giá trị freeship tối đa (VNĐ)</Label>
                  <Input
                    type="number"
                    value={rewardValue.maxValue || 0}
                    onChange={(e) => updateRewardValueField('maxValue', parseInt(e.target.value) || 0)}
                    placeholder="30000"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Đơn hàng tối thiểu (VNĐ)</Label>
                  <Input
                    type="number"
                    value={rewardValue.minOrder || 0}
                    onChange={(e) => updateRewardValueField('minOrder', parseInt(e.target.value) || 0)}
                    placeholder="0"
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Mô tả</Label>
              <Input
                type="text"
                value={rewardValue.description || ''}
                onChange={(e) => updateRewardValueField('description', e.target.value)}
                placeholder="Miễn phí vận chuyển cho đơn hàng của bạn"
              />
            </FormGroup>
          </>
        );
      default:
        return (
          <Row>
            <Col md="12">
              <FormGroup>
                <Label>Giá trị</Label>
                <Input
                  type="text"
                  value={rewardValue.value || ''}
                  onChange={(e) => updateRewardValueField('value', e.target.value)}
                  placeholder="Nhập giá trị phần thưởng"
                />
              </FormGroup>
            </Col>
          </Row>
        );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
    >
      <ModalHeader toggle={toggle}>
        {editingReward ? 'Chỉnh sửa Reward' : 'Tạo Reward Mới'}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          {quizOptions.length === 0 && !editingReward && (
            <Alert color="warning" fade={false} timeout={300}>
              <i className="fa fa-exclamation-triangle me-2"></i>
              Không tìm thấy quiz nào. Vui lòng tạo quiz trước khi tạo reward.
            </Alert>
          )}

          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Quiz *</Label>
                {quizOptionsLoading ? (
                  <div className="form-control-plaintext text-muted">
                    <i className="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
                    Đang tải danh sách quiz...
                  </div>
                ) : quizOptions.length > 0 ? (
                  <Input
                    type="select"
                    value={formData.quizId || ''}
                    onChange={(e) => {
                      const selectedId = parseInt(e.target.value);
                      if (Number.isNaN(selectedId)) {
                        setFormData((prev) => ({
                          ...prev,
                          quizId: '',
                        }));
                        return;
                      }

                      setFormData((prev) => ({
                        ...prev,
                        quizId: selectedId,
                        sortOrder:
                          !editingReward && getNextSortOrder
                            ? getNextSortOrder(selectedId)
                            : prev.sortOrder,
                      }));
                    }}
                    required
                  >
                    <option value="">Chọn quiz...</option>
                    {quizOptions.map((quiz) => (
                      <option key={quiz.id} value={quiz.id}>
                        #{quiz.id} - {quiz.name}
                      </option>
                    ))}
                  </Input>
                ) : (
                  <Input
                    type="number"
                    value={formData.quizId || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      const parsed = parseInt(value);
                      if (Number.isNaN(parsed)) {
                        setFormData((prev) => ({
                          ...prev,
                          quizId: '',
                        }));
                        return;
                      }
                      setFormData((prev) => ({
                        ...prev,
                        quizId: parsed,
                        sortOrder:
                          !editingReward && getNextSortOrder
                            ? getNextSortOrder(parsed)
                            : prev.sortOrder,
                      }));
                    }}
                    placeholder="Nhập Quiz ID..."
                    required
                  />
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Tổng số câu hỏi</Label>
                <Input
                  type="number"
                  value={formData.totalQuestions || ''}
                  onChange={(e) => setFormData({...formData, totalQuestions: parseInt(e.target.value)})}
                  placeholder="10"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Số câu đúng *</Label>
                <Input
                  type="number"
                  value={formData.correctAnswers}
                  onChange={(e) => setFormData({...formData, correctAnswers: parseInt(e.target.value)})}
                  placeholder="9"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Số lượng (Quantity)</Label>
                <Input
                  type="number"
                  value={formData.quantity === null || formData.quantity === undefined || formData.quantity === '' ? '' : formData.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '') {
                      // Empty string means null (unlimited)
                      setFormData((prev) => ({...prev, quantity: ''}));
                    } else {
                      const numValue = parseInt(value, 10);
                      if (!isNaN(numValue) && numValue >= 0) {
                        setFormData((prev) => ({...prev, quantity: numValue}));
                      }
                    }
                  }}
                  onBlur={(e) => {
                    // Ensure value is set even if user types and leaves
                    const value = e.target.value;
                    if (value !== '' && value !== null && value !== undefined) {
                      const numValue = parseInt(value, 10);
                      if (!isNaN(numValue) && numValue >= 0) {
                        setFormData((prev) => ({...prev, quantity: numValue}));
                      }
                    }
                  }}
                  placeholder="Để trống = không giới hạn"
                  min="0"
                />
                <small className="text-muted">Để trống nếu không giới hạn số lượng</small>
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Message *</Label>
                <Input
                  type="textarea"
                  rows="3"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  placeholder="Xuất sắc! Bạn đã hoàn thành xuất sắc bài quiz"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Reward Type *</Label>
                <Input
                  type="select"
                  value={formData.rewardType}
                  onChange={(e) => handleRewardTypeChange(e.target.value)}
                  required
                >
                  <option value="topup">💰 Topup (Nạp tiền điện thoại)</option>
                  <option value="points">⭐ Points (Điểm tích lũy)</option>
                  <option value="badge">🏆 Badge (Huy hiệu)</option>
                  <option value="voucher">🎫 Voucher (Phiếu giảm giá)</option>
                  <option value="gift">🎁 Gift (Quà tặng)</option>
                  <option value="coupon">🎟️ Coupon (Mã giảm giá)</option>
                  <option value="discount">💸 Discount (Giảm giá %)</option>
                  <option value="freeship">🚚 Freeship (Miễn phí ship)</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Alert color="light" className="py-2" fade={false} timeout={300}>
            <i className="fa fa-info-circle me-2"></i>
            Điền thông tin phù hợp cho loại phần thưởng đã chọn. Các trường giá trị sẽ thay đổi tương ứng.
          </Alert>

          {renderRewardValueInputs()}

          <Row className="mt-3">
            <Col md="6">
              <FormGroup>
                <Label>Sort Order</Label>
                <Input
                  type="number"
                  value={formData.sortOrder}
                  onChange={(e) => setFormData({...formData, sortOrder: parseInt(e.target.value)})}
                  placeholder="1"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="d-block">Status</Label>
                <div className="form-check form-switch mt-2">
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                  />
                  <Label className="form-check-label">
                    {formData.isActive ? 'Active' : 'Inactive'}
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" type="submit">
            <i className="fa fa-save me-2"></i>
            {editingReward ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default RewardModal;

